import { Outlet, Navigate } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import { ROUTES, APP_NAME } from '@/config/constants'

const AuthLayout = () => {
  const { isAuthenticated } = useAuth()

  // Redirect to home if already authenticated
  if (isAuthenticated) {
    return <Navigate to={ROUTES.HOME} replace />
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-blue to-primary-purple p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-5xl font-black text-white mb-3">{APP_NAME} 🎮</h1>
          <p className="text-xl text-white font-semibold mb-2">Educational Games for Kids</p>
          <p className="text-white/90">Fun learning adventures that keep young minds engaged and growing!</p>
        </div>
        
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <Outlet />
        </div>
      </div>
    </div>
  )
}

export default AuthLayout
